import { TableCellId } from 'app/pages/loanApplication/tabs/underwriting/tabs/loanBundleHistoryAndConsent/documentExpirationDates/DocumentExpirationDates.constants';

import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: TableCellId.TITLE,
    label: 'Title',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: TableCellId.START_DATE,
    label: 'Start Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: TableCellId.EXPIRES_IN_DAYS,
    label: 'Expires in days',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const underwritingDocumentExpirationDatesForm = {
  name: FormNames.UNDERWRITING_DOCUMENT_EXPIRATION_DATES,
  label: 'Document Expiration Dates',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
